import React from 'react';
import { FileQuestion, Plus } from 'lucide-react';
import Button from './Button';

const EmptyState = ({
  icon: Icon = FileQuestion,
  title = 'No data found',
  description = 'Get started by creating a new item.',
  actionLabel,
  onAction,
  children,
  className = '',
}) => {
  return (
    <div className={`empty-state py-12 px-4 ${className}`}>
      <div className="flex flex-col items-center justify-center text-center max-w-md mx-auto">
        <div className="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mb-4">
          <Icon className="w-8 h-8 text-neutral-400" />
        </div>

        <h3 className="text-lg font-semibold text-neutral-900 mb-2">
          {title}
        </h3>

        {description && (
          <p className="text-sm text-neutral-600 mb-6">
            {description}
          </p>
        )}

        {children}

        {actionLabel && onAction && (
          <Button
            variant="primary"
            icon={Plus}
            onClick={onAction}
          >
            {actionLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
